import { useEffect } from 'react';

import { client } from 'client/client.gen';
import { installDeadSessionInterceptor } from 'helpers/deadSession';

/**
 * Mounts the dead-session 401 interceptor for the app's lifetime: any API
 * 401 while Clerk still believes a user is signed in ends the session and
 * returns the user to /login (see helpers/deadSession).
 */
export const useAxiosAuthInterceptor = () => {
  useEffect(() => installDeadSessionInterceptor(client.instance), []);
};
